import React from 'react';

/**
 * Icons for the feedback choices.
 *
 * The kit's set covers the invoice screens; these are the three this
 * module needs and nothing more. Same 24x24 stroked grid, so they sit
 * beside the kit's icons without looking borrowed.
 *
 * They exist because "Bug / Improvement / Feature" as three identical
 * grey rectangles is a decision you have to read. With a mark on each it
 * is a decision you can see.
 */
export const FEEDBACK_ICONS = {
  // A broken thing: a triangle with a bang in it.
  bug: (
    <>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </>
  ),
  // Something that works but badly: sliders, waiting to be adjusted.
  improvement: (
    <>
      <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3" />
      <path d="M1 14h6M9 8h6M17 16h6" />
    </>
  ),
  // Something that is not there yet.
  feature: (
    <>
      <path d="m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z" />
      <path d="M19 15.5v3M17.5 17h3" />
    </>
  ),
  // An image, for the attach prompt.
  image: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="m21 15-5-5L5 21" />
    </>
  ),
  // The launcher's mark, repeated on the dialog so the two read as one
  // object rather than a button and an unrelated form.
  idea: (
    <>
      <path d="M9 18h6M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2Z" />
    </>
  ),
};
